import { UseQueryResult } from '@tanstack/react-query';
import { EmployeeApiListEmployeesRequest, EmployeeListDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export function useEmployeeList(
  parameters?: Partial<EmployeeApiListEmployeesRequest>,
  options?: { enabled?: boolean; staleTime?: number },
): UseQueryResult<EmployeeListDTO, Error> {
  return useTenantQuery(
    ['employees', parameters, apis.employee.listEmployees.name],
    tenantId =>
      apis.employee
        .listEmployees({
          tenantId,
          ...parameters,
        })
        .then(res => res.data),
    {
      staleTime: Infinity,
      ...options,
    },
  );
}
